import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import { USER_ID_ATTRIBUTE } from '../../constants';
import type { UserMentionElement } from '../../types';

export const USER_MENTION_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'user-mention': (node: UserMentionElement) => {
        if (!node.user) {
            return '';
        }
        return `<span ${USER_ID_ATTRIBUTE}="${escapeHTML(node.user.id)}">${escapeHTML(node.user.fullName)}</span>`;
    },
};
